import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 141.5 147.72",
  "content": "<symbol viewBox=\"0 0 141.5 147.72\" id=\"icon-search\">\r\n    <path d=\"M111.79,103.88A63.31,63.31,0,1,0,96.65,117l30.7,30.69,14.15-14.14Zm-48.51,2.69a43.29,43.29,0,1,1,43.29-43.28A43.33,43.33,0,0,1,63.28,106.57Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/search.svg
// module id = ./app/general/svg/search.svg
// module chunks = app